export default "__VITE_ASSET__CHZKMWl2__"